<i [class]="'fa fa-2x float-left mr-2 fa-' + faIcon"></i>
<h3 class="font-weight-light text-muted float-left" style="margin-top: .4rem">{{pageTitle}}</h3>